import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {revertLocationParamsConvertion} from 'app/store/sweet-api/utils';

import type {
  ProcessDashboardFetchParamsType,
  ProcessLocationParamsType,
} from './types';
import type {DefaultRootState} from 'react-redux';
import type {ContentType} from 'sweet-types';

interface DashboardState {
  filters: ProcessLocationParamsType;
  relations: Record<ContentType, boolean> | Record<string, never>;
}

interface ToggleDashboard {
  contentType: ContentType;
  isOpen: boolean;
}

const initialState: DashboardState = {
  filters: {} as ProcessLocationParamsType,
  relations: {},
};

export const processesSlice = createSlice({
  name: 'processes',
  initialState,
  reducers: {
    toggleDashboardRelation(state, action: PayloadAction<ToggleDashboard>) {
      state.relations[action.payload.contentType] = action.payload.isOpen;
    },
    setProcessesFilters(
      state,
      action: PayloadAction<ProcessDashboardFetchParamsType>
    ) {
      state.filters = revertLocationParamsConvertion(action.payload);
    },
  },
});

export const {toggleDashboardRelation, setProcessesFilters} =
  processesSlice.actions;

export const selectProcessesFilters = (state: DefaultRootState) =>
  state.processes.filters;
